export default () => {
	document.body.style.overflow = 'hidden';
};
